import cn from 'classnames';

import styles from './SplitLine.module.scss';

type SplitLineProps = {
    className?: string;
};

export const SplitLine = (props: SplitLineProps) => (
    <div className={cn(styles.splitLine, props.className)} />
);
